@if (reference?.decline) {
  <div class="alert alert-danger fadeIn">
    <div class="row justify-content-center align-items-center">
      <div class="col-12"><i class="lnr lnr-warning me-2" aria-hidden="true"></i>{{ 'REFERENCE.ALERTS.DECLINED.DESCRIPTION' | translate }}</div>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="mb-0 ms-4 small">{{ 'REFERENCE.ALERTS.DECLINED.COMMENT' | translate : { comment: reference?.decline.comment || '-' } }}</p>
      </div>
    </div>
  </div>
}
@if (answers?.length > 0 && sharingWarning && settings?.is_references_consent_enabled) {
  <div class="alert alert-warning fadeIn mb-2"><i class="lnr lnr-warning" aria-hidden="true"></i>{{ sharingWarning | translate }}</div>
}
@if (reference?.has_same_ip) {
  <div class="alert alert-warning fadeIn mb-2">
    <div class="row justify-content-center align-items-center">
      <div class="col-12 col-md-11 d-flex align-items-center"><i class="lnr lnr-warning me-2" aria-hidden="true"></i>
      <div data-testid="ip-conflict-banner-message" [innerHTML]="'REFERENCE.IP_ADDRESS.CANDIDATE_REFERENCE' | translate"></div>
    </div>
    <div class="col-12 col-md-1 text-end"><button class="btn btn-link p-0 text-reset text-decoration-none" type="button" data-testid="ip-conflict-dismiss" (click)="openClearIpConflictModalFn()" [tooltip]="'REFERENCE.IP_ADDRESS.CLEAR' | translate" container="body"><i class="lnr lnr-cross" aria-hidden="true"></i></button></div>
  </div>
</div>
}
@if (isPending) {
  <div class="alert v-alert-primary fadeIn">
    <div class="row justify-content-center align-items-center">
      <div class="col-12 col-md-9"><i class="lnr lnr-warning me-2" aria-hidden="true"></i>{{ 'REFERENCE.ALERTS.PENDING_REVIEW.DESCRIPTION' | translate }}</div>
      <div class="col-12 col-md-3 text-end"><button class="btn v-btn-primary" type="button" (click)="approveReference()" [disabled]="isApproving">{{ 'REFERENCE.ALERTS.PENDING_REVIEW.APPROVE' | translate }}</button></div>
    </div>
  </div>
  }@if (reference && !reference.filled_at && answers?.length === 0) {
  <div class="alert v-alert-primary fadeIn mb-2">
    <div class="row justify-content-center align-items-center">
      <div class="col-12 col-md-8">{{ 'REFERENCE.COMPLETE.DESCRIPTION' | translate : { reference: reference.full_name } }}</div>
      <div class="col-12 col-md-4 text-end"><a class="btn v-btn-primary" [routerLink]="['/references', reference.id]" [queryParams]="settings?.is_plugins_multi_languages_enabled ? { 'lng': reference.language } : null" target="_blank" rel="noopener noreferrer">{{ 'REFERENCE.COMPLETE.CTA' | translate }}</a></div>
    </div>
  </div>
  @if (!reference?.is_pending) {
    <div class="alert v-alert-primary fadeIn">
      <div class="row justify-content-center align-items-center">
        <div class="col-12 col-md-9">{{ 'REFERENCE.REQUEST_SENT' | translate : { date: reference.created_at | dateFormat : 'MMM DD, YYYY hh:mma' } }}</div>
        <div class="col-12 col-md-3 text-end">@if (reference?.is_reminders_enabled && !isReminderDisabled && !reference.reminder.count_exceeded && !reference.reminder.rate_exceeded) {
          <button class="btn v-btn-primary fadeIn" type="button" (click)="sendReferenceReminder()"><i class="lnr lnr-alarm-ringing me-2" aria-hidden="true"></i>{{ 'BUTTONS.REMINDERS.SEND' | translate }}</button>
        }
        @if (reference?.is_reminders_enabled && isReminderDisabled || reference.reminder.count_exceeded || reference.reminder.rate_exceeded) {
          <div class="btn v-btn-primary disabled" [tooltip]="reference.reminder.latest_sent_at | dateFormat : 'MMM DD, YYYY hh:mma'" container="body"><i class="lnr lnr-alarm-snooze me-2" aria-hidden="true"></i>{{ 'BUTTONS.REMINDERS.SENT' | translate }}</div>
        }
        @if (!reference?.is_reminders_enabled) {
          <div class="btn v-btn v-btn-secondary disabled"><i class="lnr lnr-warning me-2" aria-hidden="true"></i>{{ 'BUTTONS.REMINDERS.DISABLED' | translate }}</div>
        }
      </div>
    </div>
  </div>
}
}<app-modals [title]="'REFERENCE.IP_ADDRESS.CONFIRM.TITLE'" [openModal]="openClearIpConflictModal" [closeModal]="closeClearIpConflictModal" [whenModalClose]="clearIpConflict" [deleteKey]="'BUTTONS.CLEAR' | translate" [isButtonsDisabled]="isClearingIpConflict">
<p [innerHTML]="'REFERENCE.IP_ADDRESS.CONFIRM.DESCRIPTION' | translate : { fullName: $safeNavigationMigration(reference?.full_name) }"></p>
</app-modals>
